import './App.scss';
import {
    BrowserRouter as Router,
} from "react-router-dom";

import Main from "./components/Main";

function App() {
    return (

        <Router>
            <div>
                <Main/>
            </div>
        </Router>

    );
}

// function Users() {
//     return <h2>Users</h2>;
// }


export default App;
